import React from 'react';

import { Button } from 'components/ui/button';
import { useConversationContext } from '../../conversation_context';

import type { InlineToolCall, OfferNextStepToolCall } from '../types';

interface Props {
  question: string;
  reply: string;
}

function isOffer(toolCall: InlineToolCall): toolCall is InlineToolCall & OfferNextStepToolCall {
  return toolCall.name === 'offer_next_step';
}

export function offeredStep(toolCalls: InlineToolCall[]) {
  return toolCalls.find(isOffer)?.metadata.question || null;
}

function textOf(html: string) {
  return (new DOMParser().parseFromString(html, 'text/html').body.textContent || '').replace(/\s+/g, ' ');
}

export function NextStepOffer({ question, reply }: Props) {
  const { busy, send } = useConversationContext();
  const asked = textOf(reply).includes(question.replace(/\s+/g, ' ').trim());

  return (
    <div className="d-flex flex-column align-items-start gap-2 mt-2">
      {!asked && <span>{question}</span>}
      <Button
        aria-label={`Yes: ${question}`}
        disabled={busy}
        label="Yes"
        size="sm"
        variant="outline"
        onClick={() => send('Yes')}
      />
    </div>
  );
}
